import React from 'react';
import { Row, Col, Alert } from 'react-bootstrap';

// eslint-disable-next-line no-unused-vars
import { QUESTIONS } from '../../constants.jsx';
import Button from '../../components/button/button';
import PaymentContainer from '../../components/paymentschedule/paymentschedule';
import HeaderTable from '../../components/headertable/headertable';
import Disclaimer from '../../components/disclaimer/disclaimer.jsx';
import { resize } from '../../utils/calculate.jsx';

const Results = props => {
  const {
    payments,
    onReset,
    onBack,
    resultString,
    disclaimer,
    incurredAmount: [incurredAmount],
    incurredDate: [incurredDate],
    finalPaymentDate: [finalPaymentDate],
  } = { ...props };
  const fullPayment = payments.length === 202;

  React.useEffect(() => {
    resize();
  });

  return (
    <>
      <h3>Payment Schedule</h3>
      <br />
      <HeaderTable
        startDate={incurredDate}
        finalDate={finalPaymentDate}
        amount={incurredAmount}
      />
      <br />

      <p>{QUESTIONS.RESULTS} </p>
      <PaymentContainer
        payments={payments}
        resultString={resultString}
        incurredDate={incurredDate}
        incurredAmount={incurredAmount}
      />

      {fullPayment ? (
        <>
          <br />
          <Alert key={0} variant="warning">
            <h5>Your payment plan exceeds 200 payments</h5>
            <p>This calculator can only calculate a maximum of 200 payments.</p>
          </Alert>
        </>
      ) : null}

      <Disclaimer content={disclaimer} />

      <Row className="button-wrapper">
        <Col className="no-margin">
          <Button title="Back" variant="secondary" onClick={onBack} />
        </Col>
        <Col>
          <Button title="Start again" variant="primary" onClick={onReset} />
        </Col>
      </Row>
    </>
  );
};

export default Results;
